module.exports = __webpack_public_path__ + "static/media/Design_Track_Icon.5a0cde7c.svg";